import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";

export function tokenRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/token",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "client-applications",
            name: "client-applications",
            component: () =>
              import("core-fe-lib/components-shadcn/admin/ClientApplicationListPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "client-applications/new",
            name: "new-client-application",
            component: () =>
              import("core-fe-lib/components-shadcn/admin/ClientApplicationEditPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "client-applications/:id/edit",
            name: "edit-client-application",
            component: () =>
              import("core-fe-lib/components-shadcn/admin/ClientApplicationEditPage.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "client-applications/:id/tokens",
            name: "api-tokens",
            component: () =>
              import("core-fe-lib/components-shadcn/admin/APITokenListPage.vue"),
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  };
}
